export enum ToastType {
	INFO = 'info',
	ERROR = 'error',
}
